import { FOOTER_TYPE } from '@/constants/footer';

export const setFooterOptions = (footerType) => {
	let opt = {
		withNewsletter: true,
		withFooterHeader: true,
		withFooterHeaderCheckout: false,
		withFooterSecond: true,
		withBottomLink: true,
		withLegalNotice: true,
	};

	switch (footerType) {
		case FOOTER_TYPE.CHECKOUT:
		case FOOTER_TYPE.PRIMEUR_CHECKOUT:
			opt = {
				...opt,
				withNewsletter: false,
				withFooterHeader: false,
				withFooterHeaderCheckout: true,
				withFooterSecond: false,
				withBottomLink: false,
			};
			break;
		case FOOTER_TYPE.BLOG:
			opt = {
				...opt,
				withFooterHeader: false,
				withFooterSecond: false,
				withBottomLink: false,
			};
			break;
		case FOOTER_TYPE.ADMIN:
		case FOOTER_TYPE.ACCOUNT:
		case FOOTER_TYPE.AUTHENTICATION:
		case FOOTER_TYPE.CELLAR:
		case FOOTER_TYPE.LANDING:
		case FOOTER_TYPE.PRIMEUR:
			opt = {
				...opt,
				withNewsletter: false,
			};
			break;
		default:
	}

	return opt;
};
